import AuthService from "../../services/auth/AuthService";
import { ELanguage } from "../enums/language";
import IFloor from "../floor";
import ILocal from "../local";
import IAdminPageBuildingDetail from "../adminPage/adminPageBuildingDetail";
import { IPropertyGroup } from "../propertyGroup";
import IUser from "../user";

export enum EFieldType {
    Text,
    Input,
    Select,
    Image,
    Rating,
}

export enum EValueType {
    SingleLineText,
    MultiLineText,
    Number,
    Date,
    Boolean,
}

export enum EFormType {
    ServiceRequest = 2,
    WorkAccident = 3,
    Undefined = -99,
}

export const propertyGroupRelatedForms = [EFormType.WorkAccident];
export const buildingRelatedForms = [EFormType.ServiceRequest];

export type EFieldTypeKey = keyof typeof EFieldType;
export type EValueTypeKey = keyof typeof EValueType;
export type EFormTypeKey = keyof typeof EFormType;

export interface IFieldOption {
    value: string;
    id: number;
}

export interface IField {
    id: string;
    position: number;
    fieldType: EFieldType;
    valueType: EValueType;
    text: string;
    values: IFieldOption[];
    options: IFieldOption[];
    required: boolean;
    multiselect: boolean;
    isTranslated: boolean;
}

export interface IPage {
    pageNumber: number;
    fields: IField[];
}

export interface IForm {
    id: number;
    name: string;
    description: string;
    emails: string[];
    formType: EFormType;
    lang: ELanguage;
    userId?: number;
    propertyGroupId?: number;
    buildingId?: number;
    localId?: number;
    date: Date;
    pages: IPage[];
    groupId: number;
    isNameTranslated: boolean;
    buildings: IFormBuilding[];
    propertyGroups: IFormPropertyGroup[];
    propertyGroup?: IPropertyGroup;
    building?: IAdminPageBuildingDetail;
    floor?: IFloor;
    local?: ILocal;
    user?: IUser;
}

export interface IFormBuilding {
    id: number;
    formId: number;
    buildingId: number;
    isActive: boolean;
}

export interface IFormPropertyGroup {
    id: number;
    formId: number;
    propertyGroupId: number;
    isActive: boolean;
}

export const DEFAULT_FORM: IForm = {
    name: "",
    description: "",
    emails: [],
    id: 0,
    buildingId: 0,
    date: new Date(),
    pages: [
        {
            pageNumber: 1,
            fields: [],
        },
    ],
    lang: ELanguage.French,
    formType: EFormType.Undefined,
    groupId: 0,
    isNameTranslated: false,
    buildings: [],
    propertyGroups: [],
};
